export default __webpack_public_path__ + "static/media/inex3.db1e7a44.svg";